import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors } from "@usereactify/search";

import { Search } from "@app/scripts/reactify/search/components/search";

// The search drawer (instant-search) is imported after this module and mounts from the same bundle. Reactify's
// getData() throws when #reactify-data is absent, which snippets/reactify.liquid omits when the product discovery
// provider is set to Nosto. An uncaught throw here aborts module evaluation and the drawer never mounts, so check for
// the data node instead of letting the SDK throw.
if (window.location.pathname.startsWith("/search") && document.getElementById("reactify-data")) {


    const ReactifySearchFactory = new ReactifySearchLiquidFactory({
        mode: "search",
        additionalComponentIds: ["TagFilter"],
        includeFields: ["title", "tags", "metafields", "variants.*", "images", "media"],
        excludeFields: [],
    });

    const ReactifySearchProvider = ReactifySearchFactory.getProvider();
    const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
    const ReactifySearchData = ReactifySearchFactory.getData();

    ReactDOM.render(
        <React.StrictMode>
            <ReactifySearchProvider>

                <Sensors />
                <Search search={ReactifySearchData} />
            </ReactifySearchProvider>
        </React.StrictMode>,
        ReactifySearchMountNode
    );
}
